<div class="">
  <button class="close close-button" (click)="close()" mat-button><i class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label class="popupTitle">Reset Password</label>
    <label class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <mat-dialog-content style="padding-top: 3%;">
    <form action="index.html">
      <!-- -->
      <div class="form-floating mb-3">
        <input class="form-control" id="floatingInput" type="username" [(ngModel)]="resetData.userName"
          [ngModelOptions]="{standalone: true}" placeholder="Username" required disabled>
        <label for="username">Username</label>
      </div>
      <div class="row">
        <div class="col-md-11">
          <div class="form-floating mb-3">
            <input class="form-control" id="floatingInput" [type]="changetypeAddAndEditPassword? 'password' : 'text' "
              [(ngModel)]="resetData.oldPassword" placeholder="Old Password" [ngModelOptions]="{standalone: true}"
              required noCopyPaste>
            <label for="oldpassword">Old Password</label>
          </div>
        </div>
        <div class="col-md-1" style="margin-top: 3%;"> <span class="eyeicon-container" (click)="showPassword()">
            <i
              [class]="changetypeAddAndEditPassword ? 'fas fa-eye-slash':'fa fa-fw fa-eye field-icon toggle-password'  "></i>
          </span></div>
      </div>

      <div class="row">
        <div class="col-md-11">
          <div class="form-floating mb-3">
            <input class="form-control" id="floatingInput"
              [type]="changetypeAddAndEditnewPassword? 'password' : 'text' " [(ngModel)]="resetData.newPassword"
              placeholder="New Password" [ngModelOptions]="{standalone: true}" required noCopyPaste>
            <label for="oldpassword">New Password</label>
          </div>
        </div>
        <div class="col-md-1" style="margin-top: 3%;"> <span class="eyeicon-container" (click)="shownewPassword()">
            <i
              [class]="changetypeAddAndEditnewPassword ? 'fas fa-eye-slash':'fa fa-fw fa-eye field-icon toggle-password'  "></i>
          </span></div>
      </div>
      <!-- <div class="form-group textalign">
              <button class="col-sm-3" mat-raised-button color="primary" (click)="send_forgot_Password()">Send</button>
              
            </div> -->
    </form>

  </mat-dialog-content>
  <mat-dialog-actions class="btn-align">

    <button mat-raised-button (click)="resetPassword()" color="primary">Reset</button>
    <!-- <button mat-raised-button (click)="regist()"  color="warn">Override Session</button> -->
  </mat-dialog-actions>
</div>